
<script>
    import { onMount } from 'svelte';
  
    let canvas;
    let ctx;
    const colors = ['#4B0082', '#483D8B', '#008B8B', '#008080'];
    let shapes = [];
  
    function createShape() {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 50 + 20,
        color: colors[Math.floor(Math.random() * colors.length)],
        glare: false,
        glareTimer: 0
      };
    }
  
    function drawShape(shape) {
      ctx.beginPath();
      ctx.moveTo(shape.x, shape.y);
      ctx.lineTo(shape.x + shape.size, shape.y + shape.size / 2);
      ctx.lineTo(shape.x, shape.y + shape.size);
      ctx.closePath();
      ctx.fillStyle = shape.glare ? '#FFFFFF' : shape.color;
      ctx.fill();
    }
  
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      shapes.forEach(shape => {
        drawShape(shape);
        if (Math.random() < 0.001 && !shape.glare) {
          shape.glare = true;
          shape.glareTimer = 200; // 0.2s
        }
        if (shape.glare) {
          shape.glareTimer -= 16; // Assuming 60fps
          if (shape.glareTimer <= 0) {
            shape.glare = false;
          }
        }
      });
      requestAnimationFrame(animate);
    }
  
    onMount(() => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      ctx = canvas.getContext('2d');
  
      for (let i = 0; i < 20; i++) {
        shapes.push(createShape());
      }
  
      animate();
  
      setInterval(() => {
        shapes = shapes.map(() => createShape());
      }, 3000);
  
      return () => {
        // Clean up any resources if needed
      };
    });
  </script>
  
  <canvas bind:this={canvas}></canvas>
  
  <style>
    canvas {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  </style>
  